import React, { Component } from 'react';
import { connect } from 'react-redux';
import PubNub from 'pubnub';
import styled from 'styled-components';

import ConsultationList from '../components/ConsultationList';
import FilterPane from '../components/FilterPane';
import DashboardHeader from '../components/DashboardHeader';
import ConsultationContainer from './ConsultationContainer';
import ProfileContainer from './ProfileContainer';
import { BoldText } from '../components/common/Text';
import VideoCallContainer from '../components/VideoCallContainer';
import DyteVideoContainer from '../components/DyteVideoContainer';
import { initializeChatClient } from '../services/chatClient';
import { initializeAppClient } from '../services/appClient';
import {
  endVideoCall,
  initiateVideoCall,
  setUnrepliedChannel,
} from '../actions';
import ChangeInsurer from '../components/ChangeInsurer';
import DoctorInfoUpdate from '../components/DoctorInfoUpdate';
import DyteBridge from './DyteBridge';
import IciciInstantPanel from '../components/IciciInstantPanel';
import IciciCaseNotification from '../components/IciciCaseNotification';
import BajajInstantPanel from '../components/BajajInstantPanel';
import BajajCaseNotification from '../components/BajajCaseNotification';
import AegonInstantPanel from '../components/AegonInstantPanel';
import AegonCaseNotification from '../components/AegonCaseNotification';
import LicInstantPanel from '../components/LicInstantPanel';
import LicCaseNotification from '../components/LicCaseNotification';
import { doCompleteCall, loadDoctorState } from '../actions/iciciQueue';
import {
  doCompleteCall  as doCompleteCallBajaj,
  loadDoctorState as loadDoctorStateBajaj,
} from '../actions/bajajQueue';
import {
  doCompleteCall  as doCompleteCallAegon,
  loadDoctorState as loadDoctorStateAegon,
} from '../actions/aegonQueue';
import {
  doCompleteCall  as doCompleteCallLic,
  loadDoctorState as loadDoctorStateLic,
} from '../actions/licQueue';
import { onDoctorConnect } from '../services/iciciInstantQueue';
import { onDoctorConnect as onDoctorConnectBajaj } from '../services/bajajInstantQueue';
import { onDoctorConnect as onDoctorConnectAegon } from '../services/aegonInstantQueue';
import { onDoctorConnect as onDoctorConnectLic } from '../services/licInstantQueue';
import config from '../config';

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: stretch;
`;

const OfflineBar = styled.div`
  background: #ec5d57;
  padding: 6px 0;
  color: white;
  text-align: center;
`;

const ReconnectedBar = styled(OfflineBar)`
  background: #56c02c;
`;

const OfflineText = styled(BoldText)`
  font-size: 1.8rem;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  align-items: stretch;
  overflow-y: hidden;
`;

class DashboardHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showReconnectedBar: false,
      showInfoUpdateModal: false,
      showConsentModal: false,
      showIciciPanel: false,
      iciciCaseNotification: null, // { consultationId, customerName, applicationId, gender, phone, waitSeconds }
      showBajajPanel: false,
      bajajCaseNotification: null, // { consultationId, customerName, proposalNumber, gender, phone, waitSeconds }
      showAegonPanel: false,
      aegonCaseNotification: null, // { consultationId, customerName, proposalNumber, gender, phone, waitSeconds }
      showLicPanel: false,
      licCaseNotification: null,   // { consultationId, customerName, proposalNumber, gender, phone, waitSeconds }
      dismissedCaseIds: {}, // consultationIds the doctor has manually dismissed — keyed by id
    };
    this.iciciPubNub = null;
    this.bajajPubNub = null;
    this.aegonPubNub = null;
    this.licPubNub = null;
  }

  dispatch(action) {
    this.props.dispatch(action);
  }

  componentDidMount() {
    this.dispatch(endVideoCall());
    if (!this.props.user.authToken) {
      this.props.history.push('/');
      return;
    } else {
      this.chatClient = initializeChatClient();
      this.appClient = initializeAppClient();
      // this.channel = this.props.unrepliedChannel ? this.props.unrepliedChannel : `visit-inbound-doctor-${this.props.user.doctorId}`;
      this.channel = this.props.unrepliedChannel;

      if (!this.props.unrepliedChannel) {
        this.dispatch(setUnrepliedChannel(this.channel));
      }
      console.log({ props: this.props });
      this.chatClient.subscribe(this.channel);
      if (
        ([355, 94, 1450, 199, 1451].includes(this.props.user.doctorId) &&
          this.props.user.insurer === 'ipru') || (this.props.user.isDoctorAvailableForCall && this.props.user.insurer === 'kotak-vfmr')
      ) {
        this.appClient.subscribe('app');
      }

      // Subscribe to ICICI instant queue notifications — only for real doctors (not admin/qc accounts)
      if (this.props.user.insurer === 'ipru' && this.props.user.doctorId && !this.props.user.admin && !this.props.user.qc) {
        this.setupIciciNotifications(this.props.user.doctorId);
        this.dispatch(loadDoctorState());
      }

      // Bajaj parallel — same gate, different insurer. A doctor is on exactly one
      // insurer at a time (per doctors.insurer column), so only one block runs.
      if (this.props.user.insurer === 'bajaj' && this.props.user.doctorId && !this.props.user.admin && !this.props.user.qc) {
        this.setupBajajNotifications(this.props.user.doctorId);
        this.dispatch(loadDoctorStateBajaj());
      }

      // Aegon parallel — same gate. bli-welcome doctors use the same instant
      // queue subsystem but on insurer-namespaced PubNub channels; the panel
      // and downstream redux actions handle both buckets via the doctor's
      // own insurer.
      if (
        (this.props.user.insurer === 'aegon' || this.props.user.insurer === 'bli-welcome') &&
        this.props.user.doctorId &&
        !this.props.user.admin &&
        !this.props.user.qc
      ) {
        this.setupAegonNotifications(this.props.user.doctorId, this.props.user.insurer);
        this.dispatch(loadDoctorStateAegon());
      }

      // LIC parallel.
      if (this.props.user.insurer === 'lic' && this.props.user.doctorId && !this.props.user.admin && !this.props.user.qc) {
        this.setupLicNotifications(this.props.user.doctorId);
        this.dispatch(loadDoctorStateLic());
      }

      if (
        !this.props.user.panNo ||
        !this.props.user.email ||
        !this.props.user.language
      ) {
        this.showUpdateInfoModal();
      }
    }
  }

  setupIciciNotifications(doctorId) {
    this.iciciPubNub = new PubNub({
      publishKey:   config.pubnubPublishKey,
      subscribeKey: config.pubnubSubscribeKey,
      uuid: `dashboard-icici-notif-${doctorId}`,
    });
    this.iciciPubNub.addListener({
      message: ({ message }) => {
        if (message.name === 'new_case_inbound') {
          // Don't show if already in a call or doctor already dismissed this specific case
          if (!this.props.videoCallInitiated && !this.state.dismissedCaseIds[message.consultationId]) {
            this.setState({ iciciCaseNotification: message });
          }
        }
        if (message.name === 'case_claimed') {
          // Dismiss if we're showing this specific case
          this.setState((prev) => {
            if (
              prev.iciciCaseNotification &&
              prev.iciciCaseNotification.consultationId === message.consultationId
            ) {
              return { iciciCaseNotification: null };
            }
            return null;
          });
        }
      },
    });
    this.iciciPubNub.subscribe({
      channels: [`icici-instant-doctor-${doctorId}`],
    });
    // Give PubNub ~800ms to establish the subscription, then ask backend
    // to push any waiting case notification if the doctor is already AVAILABLE
    setTimeout(() => {
      onDoctorConnect().catch(() => {});
    }, 800);
  }

  setupBajajNotifications(doctorId) {
    this.bajajPubNub = new PubNub({
      publishKey:   config.pubnubPublishKey,
      subscribeKey: config.pubnubSubscribeKey,
      uuid: `dashboard-bajaj-notif-${doctorId}`,
    });
    this.bajajPubNub.addListener({
      message: ({ message }) => {
        if (message.name === 'new_case_inbound') {
          if (!this.props.videoCallInitiated && !this.state.dismissedCaseIds[message.consultationId]) {
            this.setState({ bajajCaseNotification: message });
          }
        }
        if (message.name === 'case_claimed') {
          this.setState((prev) => {
            if (
              prev.bajajCaseNotification &&
              prev.bajajCaseNotification.consultationId === message.consultationId
            ) {
              return { bajajCaseNotification: null };
            }
            return null;
          });
        }
      },
    });
    this.bajajPubNub.subscribe({
      channels: [`bajaj-instant-doctor-${doctorId}`],
    });
    setTimeout(() => {
      onDoctorConnectBajaj().catch(() => {});
    }, 800);
  }

  setupAegonNotifications(doctorId, insurer = 'aegon') {
    this.aegonPubNub = new PubNub({
      publishKey:   config.pubnubPublishKey,
      subscribeKey: config.pubnubSubscribeKey,
      uuid: `dashboard-aegon-notif-${doctorId}`,
    });
    this.aegonPubNub.addListener({
      message: ({ message }) => {
        if (message.name === 'new_case_inbound') {
          if (!this.props.videoCallInitiated && !this.state.dismissedCaseIds[message.consultationId]) {
            this.setState({ aegonCaseNotification: message });
          }
        }
        if (message.name === 'case_claimed') {
          this.setState((prev) => {
            if (
              prev.aegonCaseNotification &&
              prev.aegonCaseNotification.consultationId === message.consultationId
            ) {
              return { aegonCaseNotification: null };
            }
            return null;
          });
        }
      },
    });
    this.aegonPubNub.subscribe({
      channels: [`${insurer}-instant-doctor-${doctorId}`],
    });
    setTimeout(() => {
      onDoctorConnectAegon().catch(() => {});
    }, 800);
  }

  setupLicNotifications(doctorId) {
    this.licPubNub = new PubNub({
      publishKey:   config.pubnubPublishKey,
      subscribeKey: config.pubnubSubscribeKey,
      uuid: `dashboard-lic-notif-${doctorId}`,
    });
    this.licPubNub.addListener({
      message: ({ message }) => {
        if (message.name === 'new_case_inbound') {
          if (!this.props.videoCallInitiated && !this.state.dismissedCaseIds[message.consultationId]) {
            this.setState({ licCaseNotification: message });
          }
        }
        if (message.name === 'case_claimed') {
          this.setState((prev) => {
            if (
              prev.licCaseNotification &&
              prev.licCaseNotification.consultationId === message.consultationId
            ) {
              return { licCaseNotification: null };
            }
            return null;
          });
        }
      },
    });
    this.licPubNub.subscribe({
      channels: [`lic-instant-doctor-${doctorId}`],
    });
    setTimeout(() => {
      onDoctorConnectLic().catch(() => {});
    }, 800);
  }

  componentDidUpdate(prevProps, prevState) {
    const { appState } = this.props;
    const prevAppState = prevProps.appState;
    if (prevAppState === 'OFFLINE' && appState === 'ONLINE') {
      this.setState(
        {
          showReconnectedBar: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              showReconnectedBar: false,
            });
          }, 3000);
        },
      );
    }
    if (
      prevProps.videoCallInitiated &&
      !this.props.videoCallInitiated &&
      prevProps.instantConsultationId
    ) {
      // Route the complete-call to the right insurer's queue. bli-welcome
      // doctors share the aegon completeCall endpoint — the backend reads
      // req.user.insurer to know which bucket to refresh.
      if (this.props.user.insurer === 'bajaj') {
        this.dispatch(doCompleteCallBajaj(prevProps.instantConsultationId));
      } else if (
        this.props.user.insurer === 'aegon' ||
        this.props.user.insurer === 'bli-welcome'
      ) {
        this.dispatch(doCompleteCallAegon(prevProps.instantConsultationId));
      } else if (this.props.user.insurer === 'lic') {
        this.dispatch(doCompleteCallLic(prevProps.instantConsultationId));
      } else {
        this.dispatch(doCompleteCall(prevProps.instantConsultationId));
      }
    }
    // Clear any pending notification when a call starts
    if (!prevProps.videoCallInitiated && this.props.videoCallInitiated) {
      this.setState({
        iciciCaseNotification: null,
        bajajCaseNotification: null,
        aegonCaseNotification: null,
        licCaseNotification:   null,
      });
    }
    // When doctor transitions back to AVAILABLE, clear dismissed list so they get fresh notifications
    const prevStatus = prevProps.iciciDoctorStatus ? prevProps.iciciDoctorStatus.status : null;
    const currStatus = this.props.iciciDoctorStatus ? this.props.iciciDoctorStatus.status : null;
    if (prevStatus !== 'AVAILABLE' && currStatus === 'AVAILABLE') {
      this.setState({ dismissedCaseIds: {} }, () => {
        onDoctorConnect().catch(() => {});
      });
    }
    const prevBajajStatus = prevProps.bajajDoctorStatus ? prevProps.bajajDoctorStatus.status : null;
    const currBajajStatus = this.props.bajajDoctorStatus ? this.props.bajajDoctorStatus.status : null;
    if (prevBajajStatus !== 'AVAILABLE' && currBajajStatus === 'AVAILABLE') {
      this.setState({ dismissedCaseIds: {} }, () => {
        onDoctorConnectBajaj().catch(() => {});
      });
    }
    const prevAegonStatus = prevProps.aegonDoctorStatus ? prevProps.aegonDoctorStatus.status : null;
    const currAegonStatus = this.props.aegonDoctorStatus ? this.props.aegonDoctorStatus.status : null;
    if (prevAegonStatus !== 'AVAILABLE' && currAegonStatus === 'AVAILABLE') {
      this.setState({ dismissedCaseIds: {} }, () => {
        onDoctorConnectAegon().catch(() => {});
      });
    }
    const prevLicStatus = prevProps.licDoctorStatus ? prevProps.licDoctorStatus.status : null;
    const currLicStatus = this.props.licDoctorStatus ? this.props.licDoctorStatus.status : null;
    if (prevLicStatus !== 'AVAILABLE' && currLicStatus === 'AVAILABLE') {
      this.setState({ dismissedCaseIds: {} }, () => {
        onDoctorConnectLic().catch(() => {});
      });
    }
  }

  componentWillUnmount() {
    if (this.chatClient) {
      this.chatClient.unsubscribe(this.channel);
    }
    if (this.iciciPubNub) {
      this.iciciPubNub.unsubscribeAll();
    }
    if (this.bajajPubNub) {
      this.bajajPubNub.unsubscribeAll();
    }
    if (this.aegonPubNub) {
      this.aegonPubNub.unsubscribeAll();
    }
    if (this.licPubNub) {
      this.licPubNub.unsubscribeAll();
    }
  }

  initiateVideoCall = () => {
    this.dispatch(initiateVideoCall());
    // this.setState({ videoCallInitiated: true });
  };
  endVideoCall = () => {
    this.dispatch(endVideoCall());
    // this.setState({ videoCallInitiated: false });
  };

  openIciciPanel = () => {
    this.setState({ showIciciPanel: true });
  };

  closeIciciPanel = () => {
    this.setState({ showIciciPanel: false });
  };

  openBajajPanel = () => {
    this.setState({ showBajajPanel: true });
  };

  closeBajajPanel = () => {
    this.setState({ showBajajPanel: false });
  };

  openAegonPanel = () => {
    this.setState({ showAegonPanel: true });
  };

  closeAegonPanel = () => {
    this.setState({ showAegonPanel: false });
  };

  openLicPanel = () => {
    this.setState({ showLicPanel: true });
  };

  closeLicPanel = () => {
    this.setState({ showLicPanel: false });
  };

  dismissCaseNotification = () => {
    this.setState((prev) => ({
      iciciCaseNotification: null,
      dismissedCaseIds: prev.iciciCaseNotification
        ? { ...prev.dismissedCaseIds, [prev.iciciCaseNotification.consultationId]: true }
        : prev.dismissedCaseIds,
    }));
  };

  dismissBajajCaseNotification = () => {
    this.setState((prev) => ({
      bajajCaseNotification: null,
      dismissedCaseIds: prev.bajajCaseNotification
        ? { ...prev.dismissedCaseIds, [prev.bajajCaseNotification.consultationId]: true }
        : prev.dismissedCaseIds,
    }));
  };

  dismissAegonCaseNotification = () => {
    this.setState((prev) => ({
      aegonCaseNotification: null,
      dismissedCaseIds: prev.aegonCaseNotification
        ? { ...prev.dismissedCaseIds, [prev.aegonCaseNotification.consultationId]: true }
        : prev.dismissedCaseIds,
    }));
  };

  dismissLicCaseNotification = () => {
    this.setState((prev) => ({
      licCaseNotification: null,
      dismissedCaseIds: prev.licCaseNotification
        ? { ...prev.dismissedCaseIds, [prev.licCaseNotification.consultationId]: true }
        : prev.dismissedCaseIds,
    }));
  };

  hideModal = () => {
    this.setState({ showInfoUpdateModal: false });
  };

  showUpdateInfoModal = () => {
    this.setState({ showInfoUpdateModal: true });
  };
  handleOpenConsentModal = () => {
    this.setState({ showConsentModal: true });
  };
  handleCloseConsentModal = () => {
    this.setState({ showConsentModal: false });
  };
  render() {
    const { appState, user } = this.props;
    const {
      showReconnectedBar, showInfoUpdateModal,
      showIciciPanel, iciciCaseNotification,
      showBajajPanel, bajajCaseNotification,
      showAegonPanel, aegonCaseNotification,
      showLicPanel,   licCaseNotification,
    } = this.state;
    const loadFilterPane = () => {
      let filterPane = null;
      if (this.props.showFilterPane) {
        filterPane = <FilterPane />;
      }
      return filterPane;
    };

    return (
      <OuterContainer>
        {appState === 'OFFLINE' && (
          <OfflineBar>
            <OfflineText>You are offline</OfflineText>
          </OfflineBar>
        )}
        {showReconnectedBar && (
          <ReconnectedBar>
            <OfflineText>Reconnecting...</OfflineText>
          </ReconnectedBar>
        )}
        <DashboardHeader
          history={this.props.history}
          initiateVideoCall={this.initiateVideoCall}
          showUpdateInfoModal={this.showUpdateInfoModal}
          onOpenIciciPanel={this.openIciciPanel}
          onOpenBajajPanel={this.openBajajPanel}
          onOpenAegonPanel={this.openAegonPanel}
          onOpenLicPanel={this.openLicPanel}
        />
        {user.changeInsurer && !this.props.videoCallInitiated ? (
          <ChangeInsurer />
        ) : (
          ''
        )}
        <BodyContainer>
          {loadFilterPane()}
          {!this.props.videoCallInitiated && <ConsultationList />}
          <ConsultationContainer
            videoCallInitiated={this.props.videoCallInitiated}
            showConsentModal={this.state.showConsentModal}
            handleCloseConsentModal={this.handleCloseConsentModal}
          />
          {!this.props.videoCallInitiated && (
            <ProfileContainer
              handleOpenConsentModal={this.handleOpenConsentModal}
            />
          )}
          {this.props.videoCallInitiated && (
            <VideoCallContainer endVideoCall={this.endVideoCall} />
          )}
          {/* {!videoCallInitiated && <ConsultationList />}
          <ConsultationContainer videoCallInitiated={videoCallInitiated} />
          {!videoCallInitiated && <ProfileContainer />}
          {videoCallInitiated && (
            <DyteVideoContainer />
          )} */}
        </BodyContainer>
        {showInfoUpdateModal && <DoctorInfoUpdate hideModal={this.hideModal} />}
        {showIciciPanel && (
          <IciciInstantPanel onClose={this.closeIciciPanel} />
        )}
        {iciciCaseNotification && !this.props.videoCallInitiated && (
          <IciciCaseNotification
            caseData={iciciCaseNotification}
            onDismiss={this.dismissCaseNotification}
          />
        )}
        {showBajajPanel && (
          <BajajInstantPanel onClose={this.closeBajajPanel} />
        )}
        {bajajCaseNotification && !this.props.videoCallInitiated && (
          <BajajCaseNotification
            caseData={bajajCaseNotification}
            onDismiss={this.dismissBajajCaseNotification}
          />
        )}
        {showAegonPanel && (
          <AegonInstantPanel onClose={this.closeAegonPanel} />
        )}
        {aegonCaseNotification && !this.props.videoCallInitiated && (
          <AegonCaseNotification
            caseData={aegonCaseNotification}
            onDismiss={this.dismissAegonCaseNotification}
          />
        )}
        {showLicPanel && (
          <LicInstantPanel onClose={this.closeLicPanel} />
        )}
        {licCaseNotification && !this.props.videoCallInitiated && (
          <LicCaseNotification
            caseData={licCaseNotification}
            onDismiss={this.dismissLicCaseNotification}
          />
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  activeConsult: state.consults.activeConsult,
  unrepliedChannel: state.consults.unrepliedChannel,
  showFilterPane: state.app.filterPane,
  user: state.user,
  pubnubChannelGroup: state.info.pubnubChannelGroup,
  appState: state.app.appState,
  videoCallInitiated: state.videoCall.videoCallInitiated,
  instantConsultationId: state.videoCall.instantConsultationId,
  iciciDoctorStatus: state.iciciQueue ? state.iciciQueue.doctorStatus : null,
  bajajDoctorStatus: state.bajajQueue ? state.bajajQueue.doctorStatus : null,
  aegonDoctorStatus: state.aegonQueue ? state.aegonQueue.doctorStatus : null,
  licDoctorStatus:   state.licQueue   ? state.licQueue.doctorStatus   : null,
});

export default connect(mapStateToProps)(DashboardHome);
